import { Text } from '@chakra-ui/react'

import Image from '@/features/Services/components/atoms/Images/Privacies'

import { TITLE_H1_STYLE, TITLE_H3_STYLE, PARAGRAPH_STYLE } from './style'

import { Policy } from '@/features/Services/types'

const HREF = 'servicePrivacy'

const TITLE = 'Privacy Policy'
const SUBTITLE = 'นโยบายความเป็นส่วนตัว'

const PRIMARY_COLOR = '#4467CD'
const SECONDARY_COLOR = '#EAF1FD'
const LINK_IMAGE = '/images/services/privacy/4.png'
const GRADIENT = `linear-gradient(0deg, rgba(105, 134, 215, 0.5) 0%, ${PRIMARY_COLOR} 100%)`

const POLICY: Policy[] = [
  {
    title: (
      <Text as="h1" sx={TITLE_H1_STYLE}>
        Privacy Policy
        <br />
        นโยบายความเป็นส่วนตัว
      </Text>
    ),
    paragraph: (
      <Text sx={PARAGRAPH_STYLE}>
        สำหรับธุรกิจที่มีการเก็บรวบรวม ใช้
        หรือเปิดเผยข้อมูลส่วนบุคคลของลูกค้าหรือผู้ใช้งาน เช่น ชื่อ-นามสกุล อีเมล
        หรือเบอร์โทรศัพท์
      </Text>
    ),
    image: '/images/services/privacy/privacy-header.svg',
    imageAspectRatio: 645 / 654,
    button: {
      label: 'สร้าง Policy ตอนนี้!',
      href: '/create/policy?template=privacy',
      logEvent: {
        ga: { category: TITLE, action: 'Click create policy' },
      },
    },
  },
  {
    title: (
      <Text as="h1" sx={TITLE_H1_STYLE}>
        Privacy Policy
        <br />
        จำเป็นอย่างไร ?
      </Text>
    ),
    paragraph: (
      <Text sx={PARAGRAPH_STYLE}>
        เพื่อแจ้งจุดประสงค์และแนวปฏิบัติของการประมวลผลข้อมูลส่วนบุคคลตามพ.ร.บ.
        คุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 สำหรับธุรกิจที่มีการเก็บรวบรวม ใช้
        หรือ เปิดเผยข้อมูลส่วนบุคคลของลูกค้าหรือผู้ใช้งาน ต้องจัดทำ
        นโยบายความเป็นส่วนตัวสำหรับลูกค้า (Privacy Policy)
      </Text>
    ),
    image: '/images/services/privacy/2.png',
    imageAspectRatio: 1,
  },
  {
    title: (
      <Text as="h2" sx={TITLE_H3_STYLE}>
        Privacy Policy
        <br />
        ครอบคลุมเรื่องอะไรบ้าง ?
      </Text>
    ),
    paragraph: (
      <Text sx={PARAGRAPH_STYLE}>
        นโยบายความเป็นส่วนตัว (Privacy Policy) ครอบคลุมไปถึง การปฏิบัติ
        และมาตรการจัดการ ด้านความปลอดภัยของบริษัทเพื่อคุ้มครองข้อมูล
        ส่วนบุคคลที่ได้เก็บรวบรวม ใช้ หรือ เปิดเผยข้อมูล
        ส่วนบุคคลและบอกวัตถุประสงค์ในการนำ ข้อมูลของลูกค้าไปประมวลผล ภายใต้ฐานใน
        การประมวลผลข้อมูลและสิทธิเกี่ยวกับข้อมูลส่วนบุคคล
      </Text>
    ),
    checkList: [
      'ปรับใช้ได้กับทุกธุรกิจ',
      'สามารถสร้างได้ทุกที่ทุกเวลา',
      'ครอบคลุมทั้ง PDPA, GDPR และ CCPA',
    ],
    image: <Image />,
  },
]

export default {
  PRIMARY_COLOR,
  SECONDARY_COLOR,
  POLICY,
  HREF,
  LINK_IMAGE,
  GRADIENT,
  TITLE,
  SUBTITLE,
}
